var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import * as React from "react";
import { useRef } from "react";
import { select } from "d3";
import discreteLegendUtil from "../Utils/discreteLegend";
import { colorsArray, RGBToHex } from "../Utils/legendCommonFunction";
import { d3ColorScales } from "../Utils/d3ColorScale";
import defaultColorTables from "../color-tables.json";
import { DEFAULT_STYLE } from "./constants";
export var DiscreteColorLegend = function (_a) {
    var discreteData = _a.discreteData, dataObjectName = _a.dataObjectName, _b = _a.colorName, colorName = _b === void 0 ? "Stratigraphy" : _b, horizontal = _a.horizontal, getColorScaleData = _a.getColorScaleData, id = _a.id, _c = _a.colorTables, colorTables = _c === void 0 ? defaultColorTables : _c, legendFontSize = _a.legendFontSize, tickFontSize = _a.tickFontSize, numberOfTicks = _a.numberOfTicks, _d = _a.legendScaleSize, legendScaleSize = _d === void 0 ? 200 : _d, _e = _a.cssLegendStyles, cssLegendStyles = _e === void 0 ? DEFAULT_STYLE : _e;
    var generateUniqueId = Math.ceil(Math.random() * 9999).toString();
    var divRef = useRef(null);
    var legendWidth;
    var legendHeight;
    if (horizontal) {
        legendHeight = "30px";
        if (legendScaleSize < 200) {
            legendWidth = 200;
        }
        else {
            legendWidth = legendScaleSize;
        }
    }
    else {
        legendWidth = "50px";
        if (legendScaleSize < 200) {
            legendHeight = 190;
        }
        else {
            legendHeight = legendScaleSize - 10;
        }
    }
    React.useEffect(function () {
        if (divRef.current) {
            select(divRef.current).select("div").remove();
            select(divRef.current).select("svg").remove();
            discreteLegend();
        }
        function discreteLegend() {
            return __awaiter(this, void 0, void 0, function () {
                var dataSet, useSelectorLegend, itemName, itemColor, res, arrayOfColors_1, d3ColorArrays_1, defaultDiscreteData, entries, sorted, colorLegend, totalRect, currentDiv, svgLegend, error_1;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            useSelectorLegend = false;
                            itemName = [];
                            itemColor = [];
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, 5, , 6]);
                            if (!(typeof colorTables === "string")) return [3 /*break*/, 4];
                            return [4 /*yield*/, fetch(colorTables)];
                        case 2:
                            res = _a.sent();
                            return [4 /*yield*/, res.json()];
                        case 3:
                            dataSet = _a.sent();
                            _a.label = 4;
                        case 4:
                            arrayOfColors_1 = typeof colorTables === "string"
                                ? colorsArray(colorName, dataSet)
                                : colorsArray(colorName, colorTables);
                            d3ColorArrays_1 = colorsArray(colorName, d3ColorScales);
                            defaultDiscreteData = {
                                discrete_1: [[], 0],
                                discrete_2: [[], 1],
                                discrete_3: [[], 2],
                                discrete_4: [[], 3],
                                discrete_5: [[], 4],
                                discrete_6: [[], 5],
                                discrete_7: [[], 6],
                                discrete_8: [[], 7],
                                discrete_9: [[], 8],
                                discrete_10: [[], 9],
                            };
                            // Main single discrete legend
                            if (!getColorScaleData || getColorScaleData.length === 0) {
                                entries = Object.entries(discreteData ? discreteData : defaultDiscreteData);
                                sorted = entries.sort(function (a, b) { return a[1][1] - b[1][1]; });
                                sorted.forEach(function (value) {
                                    var key = value[0];
                                    var val = value[1];
                                    var code = val[1];
                                    // for colortable colors
                                    if (arrayOfColors_1.length > 0) {
                                        //compare the first value in colorarray(colortable) and code from discreteData
                                        var matchedColorsArrays = arrayOfColors_1.find(function (value) {
                                            return value[0] === code;
                                        });
                                        if (matchedColorsArrays)
                                            itemColor.push({
                                                color: RGBToHex(matchedColorsArrays).color,
                                                name: key,
                                            });
                                        itemName.push(key);
                                    }
                                    // for d3 colors
                                    else {
                                        var matchedColorsArrays = d3ColorArrays_1.find(function (_value, index) {
                                            return index === code;
                                        });
                                        if (matchedColorsArrays)
                                            itemColor.push({ color: matchedColorsArrays });
                                    }
                                });
                            }
                            // Discrete legend using Colortable colors (color selector component)
                            if (getColorScaleData === null || getColorScaleData === void 0 ? void 0 : getColorScaleData.color) {
                                getColorScaleData.color.forEach(function (key) {
                                    itemColor.push({ color: RGBToHex(key).color });
                                });
                                useSelectorLegend = true;
                            }
                            // Discrete legend using d3 colors
                            if (getColorScaleData === null || getColorScaleData === void 0 ? void 0 : getColorScaleData.colorsObject) {
                                getColorScaleData.colorsObject.forEach(function (key) {
                                    itemColor.push({ color: key });
                                });
                                itemName = getColorScaleData.legendColorName;
                                useSelectorLegend = true;
                            }
                            colorLegend = discreteLegendUtil(itemColor, useSelectorLegend, horizontal);
                            totalRect = void 0;
                            // Style for main horizontal legend
                            if (!useSelectorLegend) {
                                totalRect = itemColor.length;
                            }
                            // Style for color selector legend
                            else {
                                // calculate width for legend using colortable colors
                                if (getColorScaleData === null || getColorScaleData === void 0 ? void 0 : getColorScaleData.color) {
                                    totalRect = getColorScaleData.color.length;
                                }
                                // calculate width for legend using d3 colors
                                else {
                                    totalRect = getColorScaleData.colorsObject.length;
                                }
                            }
                            currentDiv = select(divRef.current);
                            // append the title
                            currentDiv
                                .append("div")
                                .text(dataObjectName)
                                .style("color", "grey")
                                .style("white-space", "nowrap")
                                .style("overflow", "hidden")
                                .style("width", "150px")
                                .style("text-overflow", "ellipsis")
                                .style("margin-bottom", horizontal ? "5px" : "0px")
                                .style("font-size", legendFontSize && legendFontSize > 0
                                ? "".concat(legendFontSize, "px")
                                : "16px")
                                .style("transform", horizontal ? "none" : "translate(-69px, 80px) rotate(270deg)");
                            svgLegend = currentDiv
                                .style("margin", horizontal ? "5px 0px 0px 15px" : "0px 5px 0px 5px")
                                .style("width", legendWidth)
                                .append("svg")
                                .call(colorLegend);
                            svgLegend
                                .attr("viewBox", horizontal ? "0 0 ".concat(totalRect, " 1.5") : "0 0 2 ".concat(totalRect))
                                .attr("preserveAspectRatio", "none")
                                .style("font-size", ".4")
                                .style("margin-left", horizontal ? "0" : "20px")
                                .attr("height", legendHeight)
                                .attr("width", horizontal
                                ? legendScaleSize < 200
                                    ? 190
                                    : legendScaleSize - 10
                                : "40px");
                            return [3 /*break*/, 6];
                        case 5:
                            error_1 = _a.sent();
                            console.error(error_1);
                            return [3 /*break*/, 6];
                        case 6: return [2 /*return*/];
                    }
                });
            });
        }
    }, [
        discreteData,
        colorName,
        colorTables,
        horizontal,
        getColorScaleData,
        dataObjectName,
        legendFontSize,
        tickFontSize,
        numberOfTicks,
        legendScaleSize,
        legendWidth,
        legendHeight,
    ]);
    return (React.createElement("div", { style: __assign({ position: "absolute", minHeight: "70px", borderRadius: "5px", zIndex: 999, margin: "10px" }, cssLegendStyles) },
        React.createElement("div", { id: id ? id : "disc-legend - ".concat(generateUniqueId), ref: divRef })));
};
//# sourceMappingURL=DiscreteLegend.js.map